import { RsValue } from '../../../models/base/BaseModel';
import {
  IUserManagementParam,
  IUserManagementResult,
} from '../../../models/user-management/UserManagementModel';
import api from '../../axios';

export const userManagementService = {
  listUsers: (odata: any): Promise<IUserManagementResult[]> => api.get('odata/User', odata),

  createUser: (data: IUserManagementParam): Promise<RsValue<IUserManagementResult>> =>
    api.post('User', data),

  deleteUser: (id: string): Promise<RsValue<boolean>> => api.delete(`User/${id}`),

  updateUser: (
    id: string,
    data: Partial<IUserManagementParam>
  ): Promise<RsValue<IUserManagementResult>> => api.put(`User/${id}`, data),

  getRoles: (): Promise<string[]> => api.get('User/roles'),

  getAllUsers: (): Promise<IUserManagementResult[]> =>
    api.get('odata/User', { params: { $top: 1000, $orderby: 'userName asc' } }),
};
